import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface BentoCardProps extends HTMLAttributes<HTMLDivElement> {
  highlight?: boolean;
}

export const BentoCard = forwardRef<HTMLDivElement, BentoCardProps>(
  ({ highlight = false, className, children, ...props }, ref) => (
    <div
      ref={ref}
      data-testid="bento-card"
      className={cn(
        "relative overflow-hidden rounded-2xl border bg-white/[0.03] backdrop-blur-xl",
        highlight
          ? "border-safety/60 shadow-[0_0_44px_-10px_rgba(255,91,0,0.5)]"
          : "border-cad/30",
        className,
      )}
      {...props}
    >
      {highlight && (
        <div
          aria-hidden
          className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-safety to-transparent"
        />
      )}
      {children}
    </div>
  ),
);

BentoCard.displayName = "BentoCard";
